import { Link } from 'react-router-dom';
import useEnableUnification from '@/enterprise/components/useEnableUnification';
import { asEnterpriseLink } from '@/utils/experienceLinkHelper';

const LogoLink = ({ children }: { children: React.ReactNode }) => {
  const enableUnification = useEnableUnification();

  return <Link to={enableUnification ? asEnterpriseLink('homepage') : asEnterpriseLink('customers')}>{children}</Link>;
};

export default LogoLink;
